import { useState } from "react";
import { ModalControls } from "../../../../customHooks/useModalControl";
import { decodeUrl, formatDate } from "../../../../helperFunctions";
import { useGetSingleCooperativeMemberQuery } from "../../../../redux/features/membership/membership.api";
import { Icon } from "../../../icons/icon";
import { ImageViewModal } from "../imageViewModal";
import { MoreDetailsModal } from "../moreDetailsModal";

export const MemberDetailsModal = ({
  memberId,
  cooperativeId,
  modalControls,
  onClose,
}: {
  memberId: number;
  cooperativeId: number;
  modalControls: ModalControls;
  onClose: () => void;
}) => {
  const [docUrl, setDocUrl] = useState<string>();

  const { modal, modalOpen, handleModalClose, handleModalOpen } = modalControls;

  const { data: member, isFetching: fetchingMember } =
    useGetSingleCooperativeMemberQuery(
      {
        form: true,
        coop: cooperativeId,
        id: memberId,
      },
      {
        refetchOnMountOrArgChange: true,
        skip: !(modalOpen && modal === "memberDetailsModal"),
      }
    );
  return (
    <>
      <MoreDetailsModal
        modalOpen={modalOpen && modal === "memberDetailsModal"}
        onModalClose={() => {
          handleModalClose();
          onClose();
        }}
        title="Member Details"
        mainData={{
          "First Name": member?.data?.User?.FirstName,
          "Last Name": member?.data?.User?.LastName,
          "Middle Name": member?.data?.User?.MiddleName,
          "Date of Birth": formatDate(member?.data?.User?.DateOfBirth),
          "Phone Number": (
            <>
              {member?.data?.User?.PhoneNumberCode}{" "}
              {member?.data?.User?.PhoneNumber}
            </>
          ),
          "Email Address": member?.data?.User?.Email,
          "Home Address": member?.data?.User?.Address,
          Country: member?.data?.User?.Country,
          State: member?.data?.User?.State,
          "Membership fee": `${member?.data?.hasPaid ? "Paid" : "Not Paid"} · ${
            member?.data?.isPaymentRequired ? "Required" : "Not Required"
          }`,
        }}
        extraInfoTitle="More Information"
        secondaryData={{
          "Personal Photograph": (
            <button
              type="button"
              className="w-fit text-pry-green-200 font-medium flex items-center gap-1 text-xs"
              disabled={!member?.data.User.Picture}
              onClick={() => {
                setDocUrl(member?.data?.User?.Picture);
                handleModalOpen("viewPhotoModal");
              }}
            >
              <Icon svg="gallery" width={16} height={16} />
              {!member?.data.User.Picture ? "No Photo" : "View"}
            </button>
          ),
          ...Object.fromEntries(
            member?.data?.formdata?.map((form) => {
              return [
                form?.Question ??
                  form?.MembershipFormFieldID?.question ??
                  "N/A",
                form?.MembershipFormFieldID?.fieldType === "file" ? (
                  <button
                    type="button"
                    className="w-fit text-pry-green-200 font-medium flex items-center gap-1 text-xs"
                    disabled={!form?.Data}
                    onClick={() => {
                      setDocUrl(form?.Data);
                      handleModalOpen("viewPhotoModal");
                    }}
                  >
                    <Icon svg="gallery" width={16} height={16} />
                    {!form?.Data ? "N/A" : "View"}
                  </button>
                ) : (
                  <p>{form?.Data ?? "N/A"}</p>
                ),
              ];
            }) ?? []
          ),
        }}
        loading={fetchingMember}
      />

      <ImageViewModal
        modalOpen={modal === "viewPhotoModal" && modalOpen}
        onModalClose={() => {
          handleModalOpen("memberDetailsModal");
        }}
        src={decodeUrl(docUrl)}
      />
    </>
  );
};
